import { Dispatch } from "react-redux";
import { AxiosError } from "axios";

import { ActionTypes, DateFieldMap } from "./action-types";
import { AuthActionCreators, IApplicationState } from "../";

import {
    IBaseResponse,
    ICluster, IClusterListResponse,
    IContactRequest,
    IContactListResponse,
    IDonorResponse, IRecipientResponse,
    IPairStatusChangeRequest, IRccapPositionDetail,
    IListItem, IUpdateClusterSwapManager, IUpdateClusterLogisticsProvider,
    IUpdateClusterComment, IUpdateClusterDate, IMatchHistoryRecipient,
    IUpdateMatchHistoryDeadline, IUpdatePositionDateTime, IRccapPositionDetailRequest,
    IGpsAutomation,
    IFailSafeAcknowledgeAlert,
    IMoveTracker,
    IDonorShieldDirect,
    IPosition,
    IGpsItem,
    IGpsBatchResult
} from "../../models";

import { IPost, IGet } from "../authorization";
import { Utility } from "../../services/utility";

import { ISwapCountResponse } from "../../views/swap-management/models";
import { ClusterDateField, MatchHistoryType, PositionDateField, ActiveLogisticsPlan } from "../../enums";

import { ActionCreatorsLookupData } from './actions-lookup-data';
export { ISwapLookupDataResponse, ILogisticsLookupDataResponse, IDutyOfficerResponse, ISwapLookupDataCenterListResponse } from './actions-lookup-data';

import { ActionCreatorsRccapLookupData } from './actions-rccap-lookup-data';
export { IRccapLookupDataResponse } from './actions-rccap-lookup-data';

import { ActionCreatorsLogisticsData } from './actions-logistics-data';
export { ILogisticsListResponse, ILogisticsUpdate, ILogisticsOptionResponse } from './actions-logistics-data';

import { ActionCreatorsSwapManagement } from './actions-swap-management';
import { IStrongBoxUsageContract } from "@nkr/models/strong-box/strong-box-usage";
export { IAvailableRecipient, IAvailableRecipientPairedDonor, IAvailableRecipientListResponse } from './actions-swap-management';

export interface IListItemListResponse {
    data: {
        success: boolean,
        results: IListItem[]
    }
}

export interface IRccapPositionDetailResponse {
    data: {
        success: boolean,
        results: IRccapPositionDetail
    }
}

export interface IMatchHistoryDeadline {
    recipientId: number,
    matchHistoryId: number
}

export interface IMatchHistoryDeadlineUpdate {
    list: IMatchHistoryDeadline[],
    deadlineDateTime: string
}

export interface IToggleGpsResponse {
    data: {
        success: boolean,
        results: IGpsAutomation
    }
}

export interface ISavePositionDateTimeResponse {
    data: {
        success: boolean,
        message: string,
        results: {
            isPickupDateOutsideRange: boolean,
            isDeliveryDateOutsideRange: boolean
        }
    }
}

export interface IMoveTrackerListResponse {
    data: {
        success: boolean,
        message: string,
        results: IMoveTracker[]
    }
}

export interface IDonorShieldDirectListResponse {
    data: {
        success: boolean,
        message: string,
        results: IDonorShieldDirect[]
    }
}

export interface IPositionResponse {
    data: {
        success: boolean,
        results: IPosition
    }
}

export interface IMatchingSurgeriesAndRedeyeResponse {
    data: {
        success: boolean,
        results: {
            list: string[],
            recipientDeclinedDates: string[],
            shouldBeRedeye: boolean
        }
    }
}

export interface IMatchingCallsResponse {
    data: {
        success: boolean,
        results: string[]
    }
}

export interface IGpsListResponse {
    data: {
        success: boolean,
        results: IGpsItem[]
    }
}

export interface IGpsBatchListResponse {
    data: {
        success: boolean,
        results: IGpsBatchResult[]
    }
}

const ActionCreatorsMain = {
    getSwaps: (chainStatus: number, status: number, refeshPage: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IClusterListResponse> => {
        var url = __API__ + "/swap";

        if (chainStatus > 0 && status > 0)
            url = __API__ + "/swap/query?q={status:[" + status + "],chainStatus:[" + chainStatus + "]}";

        if (chainStatus > 0 && status == 0)
            url = __API__ + "/swap/query?q={status:[],chainStatus:[" + chainStatus + "]}";

        if (chainStatus == 0 && status > 0)
            url = __API__ + "/swap/query?q={status:[" + status + "],chainStatus:[]}";

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IClusterListResponse) => {

            if (refeshPage) {
                if (response.data.success)
                    dispatch(ActionCreatorsMain.setSwaps(response.data.results));
            }
            return Promise.resolve(response);
        });
    },

    getSwapsByStatus: (clusterStatusId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IClusterListResponse> => {
        var options = {
            url: __API__ + "/swap/status" + clusterStatusId
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IClusterListResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.setSwaps(response.data.results));

            return Promise.resolve(response);
        });
    },
    getSwapsByChainId: (chainId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IClusterListResponse> => {
        var options = {
            url: `${__API__}/swap/by-chain/${chainId}`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    getSwapsInProcess: (isOps: boolean, centerId?: number) => (dispatch: Dispatch<IApplicationState>): Promise<IMoveTrackerListResponse> => {
        let url = __API__ + "/swap/status/in-process?tz=" + Utility.getTimeZoneOffset() + (centerId ? "&centerId=" + centerId : "");
        let opsUrl = __API__ + "/public/command-center/swaps-in-process?tz=" + Utility.getTimeZoneOffset() + (centerId ? "&centerId=" + centerId : "");

        var options = {
            url: !isOps ? url : opsUrl
        };

        if (!isOps) {
            return dispatch(AuthActionCreators.apiGet(options))
                .then((response: IMoveTrackerListResponse) => {
                    return Promise.resolve(response);
                })
                .catch(error => {
                    let d = {
                        data: {
                            success: false,
                            message: error,
                            results: []
                        }
                    };

                    return Promise.resolve(d);
                })
                ;
        } else {
            return dispatch(AuthActionCreators.apiGetPublic(options))
                .then((response: IMoveTrackerListResponse) => {
                    return Promise.resolve(response);
                })
                .catch(error => {
                    let d = {
                        data: {
                            success: false,
                            message: error,
                            results: []
                        }
                    };

                    return Promise.resolve(d);
                })
                ;
        }
    },
    getSwapsInProcessForOpo: (opoId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IMoveTrackerListResponse> => {
        let url = `${__API__}/swap/status/in-process-for-opo?tz=${Utility.getTimeZoneOffset()}&opoId=${opoId}`;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IMoveTrackerListResponse) => {
                return Promise.resolve(response);
            })
            .catch(error => {
                let d = {
                    data: {
                        success: false,
                        message: error,
                        results: []
                    }
                };

                return Promise.resolve(d);
            });
    },
    getSwapsForMoveTracker: (isOps: boolean, centerId?: number, clearCache?: number) => (dispatch: Dispatch<IApplicationState>): Promise<IMoveTrackerListResponse> => {
        let url = __API__ + "/swap/move-tracker?tz=" + Utility.getTimeZoneOffset() + (centerId ? "&centerId=" + centerId : "") + (clearCache ? '&clearCache=' + clearCache : '');
        let opsUrl = __API__ + "/public/command-center/move-tracker?tz=" + Utility.getTimeZoneOffset() + (centerId ? "&centerId=" + centerId : "");

        var options = {
            url: !isOps ? url : opsUrl
        };

        if (!isOps) {
            return dispatch(AuthActionCreators.apiGet(options)).then((response: IMoveTrackerListResponse) => {
                return Promise.resolve(response);
            });
        } else {
            return dispatch(AuthActionCreators.apiGetPublic(options)).then((response: IMoveTrackerListResponse) => {
                return Promise.resolve(response);
            });
        }
    },
    getSwapsForMoveTrackerForOpo: (opoId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IMoveTrackerListResponse> => {
        let url = `${__API__}/swap/move-tracker-for-opo?tz=${Utility.getTimeZoneOffset()}&opoId=${opoId}`;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IMoveTrackerListResponse) => {
            return Promise.resolve(response);
        });
    },
    getSwapsForCourier: (courierVendor: number) => (dispatch: Dispatch<IApplicationState>): Promise<IClusterListResponse> => {
        var url = __API__ + `/swap/query?q={status:[3,4,6,7,8],chainStatus:[1],fromCourierVendor:true,courierVendor:${courierVendor}}`;

        var options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IClusterListResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.setCourierSwaps(response.data.results));

            return Promise.resolve(response);
        });
    },
    setSwaps: (list: ICluster[]) => {
        return {
            type: ActionTypes.SET_SWAPS,
            list
        };
    },
    setCourierSwaps: (list: ICluster[]) => {
        return {
            type: ActionTypes.SET_SWAPS,
            list
        };
    },
    refreshSwaps: () => (dispatch: Dispatch<IApplicationState>, getState: () => IApplicationState): Promise<IClusterListResponse> => {
        let { clusterStatusId, chainStatusId } = getState().swaps;

        let url = __API__ + "/swap";

        if (clusterStatusId > 0) {
            url = __API__ + "/swap/query?q={status:[" + clusterStatusId + "],chainStatus:[" + chainStatusId + "]}";
        }

        let options = {
            url
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IClusterListResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.setSwaps(response.data.results));

            return Promise.resolve(response);
        });
    },
    refreshSwapForCourier: (chainId: number, clusterNumber: number, positionNumber: number) => (dispatch: Dispatch<IApplicationState>): Promise<IPositionResponse> => {
        var options = {
            url: __API__ + `/swap/${chainId}/${clusterNumber}/${positionNumber}`
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IPositionResponse) => {
            if (response.data.success)
                dispatch(ActionCreators.setSwapForCourier(response.data.results));

            return Promise.resolve(response);
        });
    },
    setSwapForCourier: (position: IPosition) => {
        return {
            type: ActionTypes.SET_SWAP_FOR_COURIER,
            position
        }
    },
    getSwap: (chainId: number, clusterNumber: number, positionNumber: number, isOps: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IMoveTrackerListResponse> => {
        let url = `${__API__}/swap/map/${chainId}/${clusterNumber}/${positionNumber}?tz=${Utility.getTimeZoneOffset()}`;
        let opsUrl = `${__API__}/public/command-center/swap/${chainId}/${clusterNumber}/${positionNumber}?tz=${Utility.getTimeZoneOffset()}`;

        let options = {
            url: isOps ? opsUrl : url
        };

        if (!isOps) {
            return dispatch(AuthActionCreators.apiGet(options)).then((response: IMoveTrackerListResponse) => {
                return Promise.resolve(response);
            });
        } else {
            return dispatch(AuthActionCreators.apiGetPublic(options)).then((response: IMoveTrackerListResponse) => {
                return Promise.resolve(response);
            });
        }
    },

    getCounts: () => (dispatch: Dispatch<IApplicationState>): Promise<ISwapCountResponse> => {
        var options = {
            url: __API__ + "/swap/count"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: ISwapCountResponse) => {
            return Promise.resolve(response);
        });
    },

    getContacts: (request: IContactRequest) => (dispatch: Dispatch<IApplicationState>): Promise<IContactListResponse> => {
        var options: IPost = {
            url: __API__ + "/contact",
            data: request
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IContactListResponse) => {
            return Promise.resolve(response);
        });
    },
    getDonor: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IDonorResponse> => {
        var options = {
            url: __API__ + "/donor/" + id
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IDonorResponse) => {
            return Promise.resolve(response);
        });
    },
    getRecipient: (id: number) => (dispatch: Dispatch<IApplicationState>): Promise<IRecipientResponse> => {
        var options = {
            url: __API__ + "/recipient/" + id
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IRecipientResponse) => {
            return Promise.resolve(response);
        });
    },

    resetChain: (recipientId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IRecipientResponse> => {
        var options = {
            url: __API__ + "/recipient/" + recipientId + "/reset"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IRecipientResponse) => {
            return Promise.resolve(response);
        });
    },

    saveSwapManager: (clusterId: number, swapManager: string, chainId: number, updateAllClustersInChain: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var update: IUpdateClusterSwapManager = {
            clusterId,
            swapManager,
            chainId,
            updateAllClustersInChain
        };

        var options: IPost = {
            url: __API__ + "/cluster/swap-manager",
            data: update
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.updateSwapManager(update));

            return Promise.resolve(response);
        });
    },
    updateSwapManager: (update: IUpdateClusterSwapManager) => {
        return {
            type: ActionTypes.UPDATE_SWAP_MANAGER,
            update
        };
    },

    saveChainStatus: (chainId: number, chainStatus: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IGet = {
            url: __API__ + "/chain/" + chainId + "/update-status/" + chainStatus,
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IBaseResponse) => {
                return Promise.resolve(response);
            })
            .catch((error: AxiosError) => {
                throw error;
            });
    },

    saveClusterStatus: (clusterId: number, clusterStatus: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: __API__ + "/cluster/status",
            data: {
                clusterId,
                clusterStatus
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    savePairStatus: (request: IPairStatusChangeRequest) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: __API__ + "/position/update-pair-status",
            data: request
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.updatePairStatus(request));

            return Promise.resolve(response);
        })
    },
    updatePairStatus: (update: IPairStatusChangeRequest) => {
        return {
            type: ActionTypes.UPDATE_PAIR_STATUS,
            update
        }
    },

    saveLogisticsProvider: (clusterId: number, logisticsProvider: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var update: IUpdateClusterLogisticsProvider = {
            clusterId,
            logisticsProvider
        };

        var options: IPost = {
            url: __API__ + "/cluster/logistics-provider",
            data: update
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.updateLogisticsProvider(update));

            return Promise.resolve(response);
        });
    },
    updateLogisticsProvider: (update: IUpdateClusterLogisticsProvider) => {
        return {
            type: ActionTypes.UPDATE_LOGISTICS_PROVIDER,
            update
        };
    },

    saveClusterDateTime: (type: string, clusterId: number, dateTimeValue: string) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var update: IUpdateClusterDate = {
            clusterId,
            whichDate: (type == ActionTypes.UPDATE_LOGISTICS_DATETIME ? ClusterDateField.LogisticsDateTime : ClusterDateField.KickoffDateTime),
            dateTimeValue
        };

        var options: IPost = {
            url: __API__ + "/cluster/date-time",
            data: update
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.updateClusterDateTime(type, update));

            return Promise.resolve(response);
        });
    },
    updateClusterDateTime: (type: string, update: IUpdateClusterDate) => {
        return {
            type,
            update
        };
    },

    saveChainMatchHistoryDeadline: (matchHistoryType: MatchHistoryType, clusterId: number, deadlineDateTime: string, list: IMatchHistoryRecipient[]) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var update: IUpdateMatchHistoryDeadline = {
            matchHistoryType,
            clusterId,
            deadlineDateTime,
            list
        };

        var options: IPost = {
            url: __API__ + "/match-history/deadline",
            data: update
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.updateChainMatchHistoryDeadline(update));

            return Promise.resolve(response);
        });
    },
    updateChainMatchHistoryDeadline: (update: IUpdateMatchHistoryDeadline) => {
        return {
            type: ActionTypes.UPDATE_CHAIN_MATCHOFFER_DEADLINE_DATETIME,
            update
        };
    },

    saveComment: (clusterId: number, comment: string) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var update: IUpdateClusterComment = {
            clusterId,
            comment
        };

        var options: IPost = {
            url: __API__ + "/cluster/comment",
            data: update
        }

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.updateComment(update));

            return Promise.resolve(response);
        });
    },
    updateComment: (update: IUpdateClusterComment) => {
        return {
            type: ActionTypes.UPDATE_COMMENT,
            update
        };
    },

    savePositionDateTime: (type: string, chainId: number, clusterNumber: number, positionNumber: number, dateTimeValue: string, isLoop: boolean) => (dispatch: Dispatch<IApplicationState>) => {
        let whichDate = DateFieldMap[type];

        var update: IUpdatePositionDateTime = {
            chainId,
            clusterNumber,
            positionNumber,
            whichDate,
            dateTimeValue,
            isLoop
        };

        var options: IPost = {
            url: __API__ + "/position/date-time",
            data: update
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: ISavePositionDateTimeResponse) => {
            return Promise.resolve(response);
        });
    },
    updatePositionDateTime: (type: string, update: IUpdatePositionDateTime, isPickupDateOutsideRange: boolean, isDeliveryDateOutsideRange: boolean) => {
        return {
            type,
            update,
            isPickupDateOutsideRange,
            isDeliveryDateOutsideRange
        };
    },

    createPlaceholder: (centerId: number, donorId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: __API__ + "/recipient/place-holder/" + centerId + "/" + donorId,
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    updateRexm: (donorId: number, recipientId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: __API__ + "/position/update-rexm/" + donorId + "/" + recipientId,
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    getRccapDetails: (chainId: number, clusterNumber: number, positionNumber: number) => (dispatch: Dispatch<IApplicationState>): Promise<IRccapPositionDetailResponse> => {
        var options = {
            url: __API__ + "/rccap/details/" + chainId + "/" + clusterNumber + "/" + positionNumber
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IRccapPositionDetailResponse) => {
                return Promise.resolve(response);
            }).catch((error: AxiosError) => {
                throw error;
            });
    },
    saveRccapDetails: (detail: IRccapPositionDetailRequest) => (dispatch: Dispatch<IApplicationState>) => {
        var options: IPost = {
            url: __API__ + "/rccap/details",
            data: detail
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    saveMoveTrackerNotes: (donorId: number, notes: string) => (dispatch: Dispatch<IApplicationState>) => {
        var options: IPost = {
            url: __API__ + "/donor/move-tracker-notes",
            data: {
                donorId,
                notes
            }
        }

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    // getGpsData: (imei: string, kidneyPickup: string) => (dispatch: Dispatch<IApplicationState>): Promise<IGpsListResponse> => {
    //     var options = {
    //         url: `${__API__}/gps/tracking-data?imei=${imei}&startDate=${kidneyPickup}`
    //     };

    //     return dispatch(AuthActionCreators.apiGetServiceAccount(options))
    //         .then((response: IGpsListResponse) => {
    //             return Promise.resolve(response);
    //         });
    // },
    getGpsDataBatch: (list: { imei: string, startDate: string }[], isOps: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IGpsBatchListResponse> => {
        var options = {
            url: `${__API__}/public/command-center/tracking-data-batch`,
            data: list
        };

        return dispatch(AuthActionCreators.apiPostPublic(options))
            .then((response: IGpsBatchListResponse) => {
                return Promise.resolve(response);
            });
    },
    toggleGps: (clusterId: number, positionNumber: number, toggle: boolean) => (dispatch: Dispatch<IApplicationState>): Promise<IToggleGpsResponse> => {
        var options: IPost = {
            url: __API__ + "/gps/toggle",
            data: {
                clusterId,
                positionNumber,
                toggle
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IToggleGpsResponse) => {
            if (response.data.success)
                dispatch(ActionCreatorsMain.updateGps(clusterId, positionNumber, toggle, response.data.results));

            return Promise.resolve(response);
        });
    },
    updateGps: (clusterId: number, positionNumber: number, toggleOn: boolean, gps: IGpsAutomation) => {
        return {
            type: ActionTypes.UPDATE_GPS,
            update: {
                clusterId,
                positionNumber,
                toggleOn,
                gps
            }
        }
    },
    failSafeAcknowledgeAlert: (request: IFailSafeAcknowledgeAlert) => (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        var options: IPost = {
            url: __API__ + "/fail-safe/acknowledge-alert",
            data: request
        };

        return dispatch(AuthActionCreators.apiPut(options)).then((response: IBaseResponse) => {
            return Promise.resolve(response);
        });
    },

    getDonorShieldDirect: () => (dispatch: Dispatch<IApplicationState>): Promise<IDonorShieldDirectListResponse> => {
        var options = {
            url: __API__ + "/swap/donor-shield-direct"
        };

        return dispatch(AuthActionCreators.apiGet(options)).then((response: IDonorShieldDirectListResponse) => {
            return Promise.resolve(response);
        });
    },

    getMatchingSurgeriesAndRedeye: (dateValue: string, centerId: number, excludeId: number, isRecipient: boolean, chainId: number, clusterNumber: number, positionNumber: number) => (dispatch: Dispatch<IApplicationState>): Promise<IMatchingSurgeriesAndRedeyeResponse> => {
        var options = {
            url: `${__API__}/swap/matching-surgeries-redeye`,
            data: {
                chainId,
                clusterNumber,
                positionNumber,
                dateValue,
                centerId,
                excludeId,
                isRecipient
            }
        };

        return dispatch(AuthActionCreators.apiPost(options)).then((response: IMatchingSurgeriesAndRedeyeResponse) => {
            if (response.data.success)
                dispatch(
                    ActionCreatorsMain.updateMatchingSurgeriesAndRedeye(
                        chainId,
                        clusterNumber,
                        positionNumber,
                        isRecipient,
                        response.data.results.list,
                        response.data.results.recipientDeclinedDates,
                        response.data.results.shouldBeRedeye
                    )
                );

            return Promise.resolve(response);
        });
    },
    updateMatchingSurgeriesAndRedeye: (chainId: number, clusterNumber: number, positionNumber: number, isRecipient: boolean, matchingSurgeries: string[], recipientDeclinedDates: string[], shouldBeRedeye: boolean) => {
        return {
            type: ActionTypes.UPDATE_MATCHING_SURGERIES,
            chainId,
            clusterNumber,
            positionNumber,
            isRecipient,
            matchingSurgeries,
            recipientDeclinedDates,
            shouldBeRedeye
        };
    },
    getMatchingCalls: (dateValue: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IMatchingCallsResponse> => {
        var options = {
            url: `${__API__}/swap/matching-calls`,
            data: JSON.stringify(dateValue)
        };

        try {
            return await dispatch(AuthActionCreators.apiPost(options));
        } catch (error) {
            throw error;
        }
    },
    markInternalDirectDonated: (clusterId: number, donationDate: string) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/cluster/internal-direct-donated`,
            data: {
                clusterId,
                donationDate
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    commenceMatchOffer: (clusterId: number, deadline: string, forceTargetSurgeryDate: boolean, positions: number[], clcPositions: number[], matchOfferType: number, sendEmail: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/swap/commence-match-offer`,
            data: {
                matchHistoryType: MatchHistoryType.MatchOffer,
                clusterId,
                deadline,
                forceTargetSurgeryDate,
                positions,
                clcPositions,
                matchOfferType,
                sendEmail
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    commenceSwap: (clusterId: number, usageContract: IStrongBoxUsageContract) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/email/network/commence-swap?clusterId=${clusterId}`,
            data: usageContract
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
    sendImmediateEmail: (type: number, clusterId: number, date: string, realtimeSwapFailure: boolean, useStreamlinedCancellation: boolean, preselectReversal: boolean, prereversalResponsibles: any[] | null, sendEmail: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let options: IPost = {
            url: `${__API__}/swap/send-immediate-email`,
            data: {
                type,
                clusterId,
                date,
                realtimeSwapFailure,
                useStreamlinedCancellation,
                preselectReversal,
                prereversalResponsibles: prereversalResponsibles ?? [],
                sendEmail
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options));
    },
};

export const ActionCreators = {
    ...ActionCreatorsMain,
    ...ActionCreatorsLookupData,
    ...ActionCreatorsRccapLookupData,
    ...ActionCreatorsLogisticsData,
    ...ActionCreatorsSwapManagement
};
